module.exports = __webpack_public_path__ + "static/media/buttonpaydouble2.665980aa.png";